<template>
    <div>
        <CommonSpinner v-if="isLoading" />
        <div v-else>
            <div class="profile-foreground position-relative mx-n4 mt-n4">
                <div class="profile-wid-bg">
                    <img :src="absoluteUrl('/images/bg/1920-x-835-green2.webp')" class="profile-wid-img" />
                </div>
            </div>
            <div class="pt-4 mb-4 mb-lg-3 pb-lg-4">
                <div class="row g-4">
                    <div class="col-auto">
                        <div style="width: 6rem; height: 6rem;">
                            <div @click="showProfileImg(item.image)" class="cursor-pointer img-thumbnail border border-2 w-100 h-100 rounded-circle"
                                :style="`background-image: url(${absoluteUrl(item.image)}); 
                                background-position: center center; background-size: cover;`">
                            </div>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col">
                        <div class="p-2">
                            <h3 class="text-white mb-1">{{ item.first_name }} {{ item.last_name }}</h3>
                            <p class="text-white-75 mb-2"> Status: <span class="text-uppercase">{{ $filters.textFromSlug(item.candidate.status) }}</span> </p>
                            <div class="d-sm-flex align-items-center text-white-50 gap-1">
                                <div class="me-2">
                                    <i class="ri-phone-line me-1 text-white-75 fs-16 align-middle"></i>
                                    {{ item.mobile }}
                                </div>
                                <div>
                                    <i class="ri-mail-line me-1 text-white-75 fs-16 align-middle"></i>{{
                                    item.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-auto order-last order-lg-0">
                        <div class="row text text-white-50 text-lg-center">
                            <div class="col-12">
                                <div class="p-2">
                                    <h5 class="text-white mb-1">{{ $filters.addSeparator(item.candidate.friendly_id) }}</h5>
                                    <p class="fs-14 mb-0">Unique Profile Number (UPN)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end row-->
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="position-relative">
                        <b-tabs v-model="activeTab" active-tab-class="active" pills nav-class="animation-nav profile-nav pb-5 pb-sm-4 justify-content-between justify-content-sm-start gap-2 gap-lg-3 flex-grow-1">
                            <b-tab>
                                <template v-slot:title>
                                    <i class="ri-airplay-fill align-bottom me-sm-2"></i>
                                    <br class="d-md-none">
                                    <span class="span-label">Overview</span>
                                </template>
                                <profile-overview :item="item" />
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <i class="ri-list-unordered align-bottom me-sm-2"></i>
                                    <br class="d-md-none">
                                    <span class="span-label">Education</span>
                                </template>
                                <div>
                                    <academic-records  class="mb-4"/>
                                    <career-skills />
                                </div>
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <i class="ri-flask-line align-bottom me-sm-2"></i>
                                    <br class="d-md-none">
                                    <span class="span-label">Research</span>
                                </template>

                                <div>
                                    <research-profile class="mb-4"/>
                                    <publications  class="mb-4"/>
                                    <memberships/>
                                </div>
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <i class="ri-folder-4-line align-bottom me-sm-2"></i>
                                    <br class="d-md-none">
                                    <span class="span-label">Documents</span>
                                </template>
                                <career-documents />
                            </b-tab>
                            <b-tab>
                                <template v-slot:title>
                                    <i class="ri-settings-5-line align-bottom me-sm-2"></i>
                                    <br class="d-md-none">
                                    <span class="span-label">Job Settings</span>
                                </template>
                                <div>
                                    <career-job-settings class="mb-4" :item="item" @fetchItem="fetchItem(false)"/>

                                    <employment-histories class="mb-4" /> 
                                    <experiences class="mb-4"/>
                                    <referees/>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ProfileOverview from './ProfileOverview.vue';
import CareerDocuments from './CareerDocuments.vue';
import CareerJobSettings from './CareerJobSettings.vue';
import AcademicRecords from './AcademicRecords.vue';
import CareerSkills from './CareerSkills.vue';
import EmploymentHistories from './EmploymentHistories.vue';
import ResearchProfile from './ResearchProfile.vue';
import Publications from './Publications.vue';
import Experiences from './Experiences.vue';
import Memberships from './Memberships.vue';
import Referees from './Referees.vue';

export default {
    data() {
        return {
            isLoading: true,
            item: null
        };
    },
    components: {
        ProfileOverview,
        CareerDocuments,
        CareerJobSettings,
        AcademicRecords,
        CareerSkills,
        EmploymentHistories,
        ResearchProfile,
        Publications,
        Memberships,
        Experiences,
        Referees,
    },
    computed:{
        activeUser(){
            return this.$store.state.AppActiveUser;
        },
        activeTab: {
            get() {
                return this.$route.query.tab ? +this.$route.query.tab - 1 : 0;
            },
            set(value) {
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        tab: value + 1
                    },
                    hash: this.$route.hash
                });
            }
        }
    },
    methods:{
        fetchItem(showLoader = true){
            this.isLoading = showLoader;
            this.$http.get('/profile-settings')
                .then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.item = response.data.data
                }else{
                    this.$router.push({path: '/error-404'})
                }
            })
        },
        showProfileImg(image){
            const data = { index: 0, visible: true, files: [ this.absoluteUrl(image)] }
            this.$store.commit('TOGGLE_LIGHT_BOX', data)
        },
        initializeAll(){
        }
    },
    created(){
        this.fetchItem()
    }
};
</script>


<style>
@media(max-width: 576px){
  .profile-nav .nav-item .nav-link{
    font-weight: 600;
    line-height: 1;
    padding: 0.5rem;
  }
  .profile-nav .nav-item .span-label{
    font-size: 8px;
  }
}

.animation-nav.profile-nav li a:hover, .animation-nav.profile-nav li a.active,
.animation-nav.profile-nav li button:hover, .animation-nav.profile-nav li button.active{
  color: var(--bs-primary);
  background-color: var(--bs-light) !important;
}
</style>